<template>
  <div :class="[
        classes, {
        'fadeInUp': value > 0,
        'fadeOutDown': value <= 0,
      }]"
  >
    <span v-if="label" v-html="label" class="mb-0 tool__badge-label"></span>
    <span class="text-truncate tool__badge d-block"
          v-bind:class="inputClasses"
          v-html="valueReadable"></span>
  </div>
</template>

<script>
export default {
  name: 'toolbadge',
  props: {
    value: {
      type: Number,
      required: true,
      default: 0
    },
    valueReadable: {
      type: String,
      required: false,
      default: '0'
    },
    inputClasses: {
      type: String,
      required: false,
      default: 'col-12'
    },

    classes: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    }
  }
}
</script>
